
import React from "react";
import { Button } from "@/components/ui/button";
import { 
  ChevronDown,
  ChevronUp,
  ChevronsUpDown
} from "lucide-react";
import {
  Select,
  SelectContent,
  SelectItem,
  SelectTrigger,
  SelectValue,
} from "@/components/ui/select";
import { useIsMobile } from "@/hooks/use-mobile";

export type SortDirection = "asc" | "desc" | null;
export type SortOption = {
  label: string;
  value: string;
};

interface SortButtonProps {
  options: SortOption[];
  activeSort: string | null;
  sortDirection: SortDirection;
  onSortChange: (value: string) => void;
  onDirectionChange: () => void;
}

export function SortButton({
  options,
  activeSort,
  sortDirection,
  onSortChange,
  onDirectionChange,
}: SortButtonProps) {
  const isMobile = useIsMobile();
  
  const getSortIcon = () => {
    if (!sortDirection) return <ChevronsUpDown className="h-4 w-4" />;
    return sortDirection === "asc" ? (
      <ChevronUp className="h-4 w-4" />
    ) : (
      <ChevronDown className="h-4 w-4" />
    );
  };

  return (
    <div className="flex gap-2 items-center">
      <Select value={activeSort || ""} onValueChange={onSortChange}>
        <SelectTrigger className={`${isMobile ? 'w-[120px] h-9 text-xs' : 'w-[140px] h-9'}`}>
          <SelectValue placeholder="Sort by..." />
        </SelectTrigger>
        <SelectContent>
          {options.map((option) => (
            <SelectItem key={option.value} value={option.value}>
              {option.label}
            </SelectItem>
          ))}
        </SelectContent>
      </Select>
      
      <Button
        variant="outline"
        size="icon"
        className={`${isMobile ? 'h-9 w-9 p-0' : 'h-9 w-9'}`}
        onClick={onDirectionChange}
        disabled={!activeSort}
      >
        {getSortIcon()}
      </Button>
    </div>
  );
}
